import {

  GET_USER_ROLE_RELATIONS_SUCCESS,
  ADD_USER_ROLE_RELATION_SUCCESS,
  UPDATE_USER_ROLE_RELATION_SUCCESS,
  UPDATE_USER_ROLE_RELATION ,
  DELETE_USER_ROLE_RELATION_SUCCESS,
  API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  loading: false,
  error: {},
}

const userRoleRelation = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_USER_ROLE_RELATIONS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case ADD_USER_ROLE_RELATION_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }
    case UPDATE_USER_ROLE_RELATION:
      return {
        loading: true,
      }
    case UPDATE_USER_ROLE_RELATION_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
        loading: false
      }

    case DELETE_USER_ROLE_RELATION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.userDefinitionGuid.toString() !== action.payload.toString()
        ),
      }

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default userRoleRelation